import type { QueryClient } from '@tanstack/react-query'

/**
 * s67 / ADR-0033 2i (R2 + J2) -- a PERGUNTA PENDENTE para a VIGA.
 *
 * A busca no topo (TopSearch) nao manda a pergunta sozinha: ela deixa o texto aqui, no cache do React Query, e abre a
 * VIGA. A tela do assistente (pagina ou painel) LE e APAGA o texto num passo so (`takePending`) e o envia pelo caminho de
 * sempre (mascarado, como o texto digitado). Ler-e-apagar num passo so evita a pergunta em DOBRO quando o efeito roda duas
 * vezes (StrictMode). Nada no navegador: "Sair" e a troca de empresa apagam o cache inteiro.
 */
export const ASSISTANT_PENDING_KEY = ['assistant-pending'] as const

export function setPending(qc: QueryClient, texto: string): void {
  qc.setQueryData<string | null>(ASSISTANT_PENDING_KEY, texto)
}

export function takePending(qc: QueryClient): string | null {
  const texto = qc.getQueryData<string | null>(ASSISTANT_PENDING_KEY) ?? null
  if (texto !== null) qc.setQueryData<string | null>(ASSISTANT_PENDING_KEY, null)
  return texto
}
